import {
    Component,
    Input,
} from '@angular/core';

@Component({
    selector: 'spotlight-card',
    templateUrl: './spotlight-card.component.html',
    styleUrls: ['./spotlight-card.component.scss'],
})
export class SpotlightCardComponent {
    @Input() public spotlight: any = {};
    @Input() public showOverlay = false;
    @Input() public CTA: string = '';
    @Input() public linkCTA: string = '';
}
